import SvgIcon from "@mui/material/SvgIcon";

export default function BiodiversityIcon() {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{ width: "24", height: "24", transform: "scale(1.8)" }}
    >
      <path
        d="M12.75 18C16.4779 18 19.5 15.8174 19.5 13.125C19.5 10.4326 16.4779 8.25 12.75 8.25C9.02208 8.25 6 10.4326 6 13.125C6 15.8174 9.02208 18 12.75 18Z"
        fill="#EFC52E"
      />
      <path
        d="M8.25 10.875H17.25C17.8125 10.875 18.375 11.25 18.375 11.8125C18.375 12.375 17.8125 12.75 17.25 12.75H8.25V10.875Z"
        fill="#1C4321"
      />
      <path
        d="M7.5 13.875H18C18.5625 13.875 19.125 14.25 19.125 14.8125C19.125 15.375 18.5625 15.75 18 15.75H7.5V13.875Z"
        fill="#1C4321"
      />
      <path
        d="M7.875 15.375C9.53185 15.375 10.875 14.0319 10.875 12.375C10.875 10.7181 9.53185 9.375 7.875 9.375C6.21815 9.375 4.875 10.7181 4.875 12.375C4.875 14.0319 6.21815 15.375 7.875 15.375Z"
        fill="#EFC52E"
      />
      <path
        d="M6.9375 12.4688C7.19638 12.4688 7.40625 12.2589 7.40625 12C7.40625 11.7411 7.19638 11.5312 6.9375 11.5312C6.67862 11.5312 6.46875 11.7411 6.46875 12C6.46875 12.2589 6.67862 12.4688 6.9375 12.4688Z"
        fill="#1C4321"
      />
      <path
        d="M8.8125 12.4688C9.07138 12.4688 9.28125 12.2589 9.28125 12C9.28125 11.7411 9.07138 11.5312 8.8125 11.5312C8.55362 11.5312 8.34375 11.7411 8.34375 12C8.34375 12.2589 8.55362 12.4688 8.8125 12.4688Z"
        fill="#1C4321"
      />
      <path
        d="M13.125 11.25C14.5747 11.25 15.75 9.73896 15.75 7.875C15.75 6.01104 14.5747 4.5 13.125 4.5C11.6753 4.5 10.5 6.01104 10.5 7.875C10.5 9.73896 11.6753 11.25 13.125 11.25Z"
        fill="#FDFBEB"
      />
      <path
        d="M16.5 12C17.9497 12 19.125 10.489 19.125 8.625C19.125 6.76104 17.9497 5.25 16.5 5.25C15.0503 5.25 13.875 6.76104 13.875 8.625C13.875 10.489 15.0503 12 16.5 12Z"
        fill="#FDFBEB"
      />
      <path
        d="M6.1875 13.2188C6.44638 13.2188 6.65625 13.0089 6.65625 12.75C6.65625 12.4911 6.44638 12.2812 6.1875 12.2812C5.92862 12.2812 5.71875 12.4911 5.71875 12.75C5.71875 13.0089 5.92862 13.2188 6.1875 13.2188Z"
        fill="#F1EFF7"
      />
      <path
        d="M9.5625 13.2188C9.82138 13.2188 10.0312 13.0089 10.0312 12.75C10.0312 12.4911 9.82138 12.2812 9.5625 12.2812C9.30362 12.2812 9.09375 12.4911 9.09375 12.75C9.09375 13.0089 9.30362 13.2188 9.5625 13.2188Z"
        fill="#F1EFF7"
      />
    </SvgIcon>
  );
}
